export default class Witness {
    
}